"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../../../../shared/controllers/BaseController");
var webAApi_1 = require("../../../../api/webAApi");
var UIUtils_1 = require("../../../../../shared/modules/UIUtils");
var moment = require("moment");
//export interface IFinanceDepositFilterInfo {
//    text: string;
//    value: string
//}
var AppPsySystemTransactionsListCtl = /** @class */ (function (_super) {
    __extends(AppPsySystemTransactionsListCtl, _super);
    function AppPsySystemTransactionsListCtl(errDialog) {
        var _this = _super.call(this, true) || this;
        _this.dk_brand_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.brand_title; });
        _this.dk_player_login = UIUtils_1.UIUtils.IProp2Str(function (o) { o.player_login; });
        _this.dk_player_email = UIUtils_1.UIUtils.IProp2Str(function (o) { o.player_email; });
        _this.dk_wallet_currency_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.wallet_currency_title; });
        _this.dk_amount_in_wallet_currency = UIUtils_1.UIUtils.IProp2Str(function (o) { o.amount_in_wallet_currency; });
        _this.dk_player_currency_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.player_currency_title; });
        _this.dk_amount_in_player_currency = UIUtils_1.UIUtils.IProp2Str(function (o) { o.amount_in_player_currency; });
        _this.dk_deposit_state_code = UIUtils_1.UIUtils.IProp2Str(function (o) { o.deposit_state_code; });
        _this.dk_deposit_state_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.deposit_state_title; });
        _this.dk_deposit_state_complete = UIUtils_1.UIUtils.IProp2Str(function (o) { o.deposit_state_complete; });
        _this.dk_deposit_state_error = UIUtils_1.UIUtils.IProp2Str(function (o) { o.deposit_state_error; });
        _this.dk_date_added = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_added; });
        _this.dk_date_changed = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_changed; });
        _this.dk_outer_transaction_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.outer_transaction_id; });
        _this.dk_ip_address = UIUtils_1.UIUtils.IProp2Str(function (o) { o.ip_address; });
        _this.dk_wallet = UIUtils_1.UIUtils.IProp2Str(function (o) { o.wallet; });
        _this.dk_crypto_wallet_type_code = UIUtils_1.UIUtils.IProp2Str(function (o) { o.crypto_wallet_type_code; });
        _this.dk_crypto_wallet_type_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.crypto_wallet_type_title; });
        _this._errDialog = errDialog;
        return _this;
    }
    AppPsySystemTransactionsListCtl.prototype.ResetData = function () {
        this.DATA = {
            total: 0,
            data: [],
        };
    };
    AppPsySystemTransactionsListCtl.prototype.getById = function (id) {
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === id) {
                return this.DATA.data[i];
            }
        }
        return null;
    };
    AppPsySystemTransactionsListCtl.prototype.LoadRangeDataByBrandsListEx = function (data, onDone) {
        var _this = this;
        webAApi_1.ListInnerPayTransactionsByFiltersGet.exec({
            all_payservices: data.all_payservices,
            pay_service_id_list: data.pay_service_id_list,
            offset: data.Offset,
            limit: data.Limit,
            from_year: data.from_year,
            from_month: data.from_month,
            from_day: data.from_day,
            from_hour: data.from_hour,
            from_minute: data.from_minute,
            to_year: data.to_year,
            to_month: data.to_month,
            to_day: data.to_day,
            to_hour: data.to_hour,
            to_minute: data.to_minute,
            complete_only: data.complete_only,
            transaction_part: data.transaction_part,
            is_filter_transaction_part: data.is_filter_transaction_part
        }, function (resp) {
            _this.DATA.data = [];
            _this.DATA.total = resp.total_count;
            //
            for (var i = 0; i < resp.list.length; i++) {
                _this.DATA.data.push({
                    key: resp.list[i].key_uid,
                    brand_title: resp.list[i].brand_title,
                    player_id: resp.list[i].player_id,
                    player_login: resp.list[i].player_login,
                    player_email: resp.list[i].player_email,
                    wallet_currency_title: resp.list[i].wallet_currency_title,
                    amount_in_wallet_currency: resp.list[i].amount_in_wallet_currency,
                    player_currency_title: resp.list[i].player_currency_title,
                    amount_in_player_currency: resp.list[i].amount_in_player_currency,
                    date_added: moment(resp.list[i].date_added_uts_ms).utc(false),
                    date_changed: moment(resp.list[i].date_changed_uts_ms).utc(false),
                    deposit_state_code: resp.list[i].deposit_state_code,
                    deposit_state_title: resp.list[i].deposit_state_title,
                    deposit_state_complete: resp.list[i].deposit_state_complete,
                    deposit_state_error: resp.list[i].deposit_state_error,
                    ip_address: resp.list[i].ip_address,
                    outer_transaction_id: resp.list[i].outer_transaction_id,
                    wallet: resp.list[i].wallet,
                    crypto_wallet_type_code: resp.list[i].crypto_wallet_type_code,
                    crypto_wallet_type_title: resp.list[i].crypto_wallet_type_title
                });
            }
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    return AppPsySystemTransactionsListCtl;
}(BaseController_1.BaseController));
exports.AppPsySystemTransactionsListCtl = AppPsySystemTransactionsListCtl;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/app_paysystem_transactions/ctl/AppPsySystemTransactionsListCtl.ts
// module id = 1055
// module chunks = 0